// extracted by mini-css-extract-plugin
module.exports = {"ripple":"_MediaSpinner_ripple_19-X1","ripple__circle":"_MediaSpinner_ripple__circle_kUrGo","ripple__inner-circle":"_MediaSpinner_ripple__inner-circle_3SptJ"};